module.exports = __webpack_public_path__ + "static/media/square-full.e4aab9b8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/square-full.svg
// module id = 2383
// module chunks = 0